module.exports = __webpack_public_path__ + "95277447cbb74abb6590686556aaafd5.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/nb/google_store.png
// module id = 876
// module chunks = 0